import { __assign, __awaiter, __generator } from "tslib";
import { getCustomerServiceUrl } from '../hosting/getCustomerServiceUrl';
import { app as api } from '@ekuaibao/whispered';
import { enableSupportOfflineMessage } from './featbit/feat-switch';
var initClinkWebchat = function (opts) {
    return new Promise(function (resolve, reject) {
        ;
        (window.clinkWebchatOptions = window.clinkWebchatOptions || function () {
            window.clinkWebchatOptions.options = arguments[0];
        })(opts);
        var script = document.createElement('script');
        script.defer = true;
        script.src = 'https://webchat-bj.clink.cn/webchat.js?v=' + Date.now();
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = function () {
            reject();
            console.error('clinkWebchatOptions error');
        };
    });
};
var getServiceParams = function () { return __awaiter(void 0, void 0, void 0, function () {
    var user, url, urlObj;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                user = (_b = (_a = api.getState()['@common']) === null || _a === void 0 ? void 0 : _a.userinfo) === null || _b === void 0 ? void 0 : _b.data;
                return [4, getCustomerServiceUrl(user, '7321')];
            case 1:
                url = _c.sent();
                urlObj = new URL(url);
                return [2, {
                        accessId: urlObj.searchParams.get('accessId') || '',
                        externalId: encodeURIComponent(urlObj.searchParams.get('externalId') || ''),
                        customerFields: encodeURIComponent(urlObj.searchParams.get('customerFields') || '')
                    }];
        }
    });
}); };
export var initTianRunService = function () { return __awaiter(void 0, void 0, void 0, function () {
    var params, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!enableSupportOfflineMessage()) {
                    return [2];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4, getServiceParams()];
            case 2:
                params = _a.sent();
                initClinkWebchat(__assign({ language: 'zh_CN' }, params));
                return [3, 4];
            case 3:
                error_1 = _a.sent();
                console.error(error_1);
                return [3, 4];
            case 4: return [2];
        }
    });
}); };
